import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Button, Typography, Box, Divider } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { getFaqs } from '../../actions/faqs';
import BannerHeader from '../apps/rofburns/shared-components/BannerHeader';

export default function Support() {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getFaqs());
    }, [dispatch]);

    const { faqs, loading } = useSelector(state => state.faqs);
    const accordionWidth = '75%'

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <BannerHeader>Support and FAQs</BannerHeader>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, px: 3 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <Typography variant='h6'>FAQs</Typography>
                    <Typography>Here you will find frequently asked questions - along with helpful information -
                        that will help you navigate the app.</Typography>
                </Box>
                <Box sx={{ maxWidth: accordionWidth, pl: 1, display: 'flex', flexDirection: 'column' }}>
                    {loading
                        ? <CircularProgress />
                        : faqs?.map((faq) => (
                            <Accordion key={faq._id}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls={`panel${faq._id}a-content`}
                                    id={`panel${faq._id}a-header`}
                                >
                                    <Typography variant='h7'>{faq.question}</Typography>
                                </AccordionSummary>
                                <Divider />
                                <AccordionDetails>
                                    <Typography
                                        component='div'
                                        dangerouslySetInnerHTML={{ __html: faq.answer }}
                                    />
                                </AccordionDetails>
                            </Accordion>
                        ))
                    }
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <Typography variant='h6'>Support</Typography>
                        <Typography>Your question not answered? Still need clarification? Feel free to contact us!</Typography>
                    </Box>
                    <Box>
                        <Button
                            variant='contained'
                            size='large'
                            sx={{ width: 'fit-content' }}
                            href='mailto:sarah@mycharr.app'
                        >
                            Contact Us
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}